import React from 'react';

interface DestinationLinksProps
	{
	exploreLabel?: string;
	exploreUrl?: string;
	discoverLabel?: string;
	discoverUrl?: string;
	ctaLabel?: string;
	ctaUrl?: string;
	}

export const DestinationLinks = ({ exploreLabel, exploreUrl, discoverLabel, discoverUrl, ctaLabel, ctaUrl }: DestinationLinksProps) =>
	{
	// Single-location mode (Figma node 4167:527): the two text links collapse
	// to one filled button straight into search for that location.
	if (ctaLabel)
		{
		return (
			<a className="wp-block-ocean-destinations__cta" href={ctaUrl || '#'}>
				{ctaLabel}
			</a>
			);
		}

	if (!exploreLabel && !discoverLabel)
		{
		return null;
		}

	return (
		<div className="wp-block-ocean-destinations__links">
			{exploreLabel && (
				<a className="wp-block-ocean-destinations__link wp-block-ocean-destinations__link--button" href={exploreUrl || '#'}>
					{exploreLabel}
				</a>
				)}
			{discoverLabel && (
				<a className="wp-block-ocean-destinations__link wp-block-ocean-destinations__link--text" href={discoverUrl || '#'}>
					{discoverLabel}
				</a>
				)}
		</div>
		);
	};
